import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components/ensigns';
import { SpecraEmptyState } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../lib/renderRouterLink';
/**
 * A record page whose id is missing, removed or forbidden (pangaea answers
 * NotFound for all three). One wording for every case, and it never echoes
 * the id or a name, so the page cannot be used to probe which records exist
 * (same rule as the drawer's RecordUnavailable).
 */ export function RecordUnavailableState({ tab }) {
    return /*#__PURE__*/ _jsx(SpecraEmptyState, {
        framed: true,
        "data-testid": Testids.registryRecord.unavailable,
        title: "This record isn't available.",
        description: "It may have been removed, or you may not have access to it.",
        action: /*#__PURE__*/ _jsx(SpecraButton, {
            variant: "secondary",
            asChild: true,
            "data-testid": Testids.registryRecord.back,
            children: renderRouterLink({
                href: `/registries?tab=${encodeURIComponent(tab)}`,
                children: 'Back to Registries'
            })
        })
    });
}
